import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const DocumentIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-document', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.33331 2.66667C3.33331 2.29848 3.63179 2 3.99998 2H9.09998C9.28647 2 9.46444 2.07812 9.59068 2.21539L12.4907 5.36872C12.6038 5.49176 12.6666 5.65283 12.6666 5.82V13.3333C12.6666 13.7015 12.3682 14 12 14H3.99998C3.63179 14 3.33331 13.7015 3.33331 13.3333V2.66667ZM4.66665 3.33333V12.6667H11.3333V6.07995L8.80736 3.33333H4.66665Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.82001 6.18001V2.40668H9.15334V5.51334H12.26V6.84668H8.48667C8.11848 6.84668 7.82001 6.5482 7.82001 6.18001Z'
      />
    </svg>
  );
};

export default DocumentIcon;
